import { Col, Form, Input, Row } from 'antd'
import DeliveryDetails from '../../../../../elements/DeliveryDetails'
import { get } from 'lodash'
import { defaultFormItemLayout, rules } from '../../../../../modules/FormItems'
import React from 'react'

function DeliveryAddressesForm(props) {
  const { line } = props
  const { getFieldDecorator, resetFields, getFieldValue, setFieldsValue } = props.form

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Title">
            {getFieldDecorator('title', {
              initialValue: get(line, 'title'),
              rules: rules.input,
            })(<Input placeholder={'Title'} />)}
          </Form.Item>
        </Col>
      </Row>
      <DeliveryDetails
        doc={line}
        {...{
          getFieldDecorator,
          getFieldValue,
          setFieldsValue,
          resetFields,
          type: 'Account',
        }}
      />
    </Form>
  )
}

export default Form.create()(DeliveryAddressesForm)
